import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { FormStrucItem } from 'src/lib/types/types';

// import schemas
import { Box, Typography } from '@mui/material';
import { get } from 'lodash';
import MarkdownRenderer from 'src/components/ui-component/markdown-renderer/MarkdownRenderer';
import { EMPFEHLUNG_GREMIUM_AUFLAGEN, FORM_FIELDS_TYPES, FORMANTRAG_ANDERUNG_VORHANDEN, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
import { NonRequired, RadioButtonValidation } from 'src/lib/validation/ValidationTypes';
import { InhaltTrenner, InhaltWrapper } from 'src/pages/private/online-antrag/antrag-components/Wrapper';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import { isTrue } from 'src/utils/helper';
const P = AntragSchema.attributes;

const VorbereitungFormantrag: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const isBeabsichtigt = isTrue(get(application, P.Formantrag_Vorhaben_Beabsichtigt.path));
	const hatAuflagen = get(application, P.Empfehlung_Gremium_Auflagen.path) === EMPFEHLUNG_GREMIUM_AUFLAGEN.mitAuflagen;
	const aenderungenVorhanden =
		get(application, P.Formantrag_Aenderung_Vorhanden.path, '') === FORMANTRAG_ANDERUNG_VORHANDEN.Ja44EsGibtAenderungenInDerProjektplanung46;
	return (
		<>
			<ApplicationHeading title='Vorbereitung Formantrag' description={PLATZHALTER_TEXT} />

			<>
				<InhaltWrapper>
					<Typography variant='h6' sx={{ mb: 1, fontWeight: 600 }}>
						Entscheidung Gremiumssitzung
					</Typography>
					<Typography variant='body1' sx={{ fontWeight: 500, mb: hatAuflagen ? 1 : 0 }}>
						Ihr Projektantrag wurde in der Sitzung der LOEWE-3 Auswahlkommission zur Förderung durch die LOEWE Förderlinie 3 empfohlen.
						{hatAuflagen && ' - vorbehaltlich der folgenden Auflagen:'}
					</Typography>
					{hatAuflagen && (
						<Box sx={{ pl: 2 }}>
							<MarkdownRenderer markdown={get(application, P.Empfehlung_Gremium_Uerarbeitungshinweise_Auflagen.path, '')} />
						</Box>
					)}
					<InhaltTrenner />
				</InhaltWrapper>
			</>

			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={readOnly} />

			{aenderungenVorhanden && (
				<>
					<CreateForm
						formStruc={formStrucAenderungenBereiche(application)}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={readOnly}
					/>
					<Typography sx={{ fontWeight: 600, mt: 2 }}>Änderungshinweise</Typography>
					<Typography>Bitte beschreiben Sie kurz stichpunktartig die vorgenommenen Änderungen</Typography>
					<CreateForm
						formStruc={formStrucAenderungenVorhanden(application)}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={readOnly}
					/>
				</>
			)}
			<InhaltTrenner />
			<CreateForm
				formStruc={formStrucVorhabenBeabsichtigt()}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={readOnly}
			/>
			{isBeabsichtigt && (
				<>
					<Typography sx={{ fontWeight: 600, mt: 1 }}>Bitte geben Sie Programm, Fördernde Stelle und Förderhöhe an</Typography>
					<Typography sx={{ fontWeight: 400 }}>
						(bspw. BMBF; ZIM; Sonderforschungsprogramme; Kredite, Beteiligungen, Bürgschaften aus öffentlichen Mitteln; KfW, etc.)
					</Typography>
					<CreateForm
						formStruc={formStrucFormantragFoerderhoehe(application)}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={readOnly}
					/>
				</>
			)}
		</>
	);
};

export default VorbereitungFormantrag;

const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [{ ...P.Formantrag_Aenderung_Vorhanden, type: FORM_FIELDS_TYPES.radio }],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

const formStrucAenderungenBereiche = (application: any) => {
	const aenderungenVorhanden =
		get(application, P.Formantrag_Aenderung_Vorhanden.path, '') === FORMANTRAG_ANDERUNG_VORHANDEN.Ja44EsGibtAenderungenInDerProjektplanung46;

	return aenderungenVorhanden ?
			[
				{
					fields: [{ ...P.Formantrag_Aenderung_Folgenden_Bereichen, type: FORM_FIELDS_TYPES.multiSelect }],
					userProps: { direction: 'column', columnToDivide: 1 },
				},
			]
		:	[];
};
const formStrucAenderungenVorhanden = (application: any) => {
	const aenderungenVorhanden =
		get(application, P.Formantrag_Aenderung_Vorhanden.path, '') === FORMANTRAG_ANDERUNG_VORHANDEN.Ja44EsGibtAenderungenInDerProjektplanung46;

	return aenderungenVorhanden ?
			[
				{
					fields: [{ ...P.Formantrag_Aenderungshinweise_Antragsteller, label: '', validation: [{ validateFunction: NonRequired }] }],
					userProps: { direction: 'column', columnToDivide: 1 },
				},
			]
		:	[];
};

const formStrucVorhabenBeabsichtigt = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{ ...P.Formantrag_Vorhaben_Beabsichtigt, type: FORM_FIELDS_TYPES.radio, validation: [{ validateFunction: RadioButtonValidation }] },
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

const formStrucFormantragFoerderhoehe = (application: any) => {
	const isBeabsichtigt = isTrue(get(application, P.Formantrag_Vorhaben_Beabsichtigt.path));

	return isBeabsichtigt ?
			[
				{
					fields: [{ ...P.Formantrag_Foerderhoehe, label: '' }],
					userProps: { direction: 'column', columnToDivide: 1 },
				},
			]
		:	[];
};

export const getFormStrucVorbereitungFormantrag = (application: any) => {
	return concat(
		formStruc(),
		formStrucAenderungenVorhanden(application),
		formStrucAenderungenBereiche(application),
		formStrucVorhabenBeabsichtigt(),
		formStrucFormantragFoerderhoehe(application),
	);
};
